<template>
  <div class="modal-sidebar__classes">
    <b-card card no-body v-for="(item, index) in  classesExam" class="card-item border-0 secondary-color-txt bg-transparent" :key="index"  :class="{'active':true}">
        <div class="card-wrap display-block">
          <b-card-header 
            header-tag="header" 
            role="tab" 
            class="border-0 border-rd-8 display-flex-center secondary-color-txt font-size-16 bg-transparent cursor-pointer"
            @click="openCollapse(`cat_${item.classId}`, item, index)" 
            :class="{'active primary-color font-sanpro-semibold': collapseOpen === item.classId || paramsGetQuestionsSample.classId === item.classId}" 
          >
            {{ item.name }}
          </b-card-header>
          <b-collapse :id="`cat_${item.classId}`" :visible="item.classId === paramsGetQuestionsSample.classId" accordion="my-accordion" role="tabpanel">
            <b-card-body class="p-0">
                <ul class="cat-child margin-0" >
                  <li class="d-block" v-for="(child, pos) of item.subjects" :key="pos">
                    <a 
                      @click="changeSubjects(child,item.classId)"
                      href="javascript:;"
                      class="font-sanpro primary-color-txt font-size-16 display-flex justify-content-between full-width"
                      :class="{'active': tabActive === child.subjectId}"
                    >
                      {{ child.name }}
                    </a>
                  </li>
                </ul>
            </b-card-body>
          </b-collapse>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY } from './../../_store/constants'
import { apiGetListSubjectOfTeacher, apiGetListChooseQuestion } from './../../_api/exam'

export default {
  name: 'SidebarClassesModal',
  data () {
    return {
      tabActive: 0,
      subjectIdActive: 0,
      collapseOpen: null
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['classesExam', 'paramsGetQuestionsSample'])
  },
  mounted () {
    this.initSidebar()
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetClassesExam', 'acSetParamsGetQuestionsData']),

    initSidebar () {
      let itemClassActive = {classId: this.paramsGetQuestionsSample.classId}
      let indexClassActive = this.classesExam.findIndex(cl => cl.classId === this.paramsGetQuestionsSample.classId)
      if (indexClassActive > -1) {
        this.openCollapse('', itemClassActive, indexClassActive, true)
      }
    },

    openCollapse(id, item, index, initSidebar = false) {
      let self = this
      this.tabActive = 0
      this.subjectIdActive = item.classId
     
      // this.acSetParamsGetQuestionsData({...this.paramsGetQuestionsSample, classId: item.classId, subjectId: initSidebar ? this.paramsGetQuestionsSample : 0 })
      this.collapseOpen = this.collapseOpen === item.classId ? '' : item.classId
      // this.$root.$emit('bv::toggle::collapse', item.classId)
      // console.log('vao day di em');
      if (!self.classesExam[index].subjects) {
        apiGetListSubjectOfTeacher({classId: item.classId}).then(res => {
          this.listsubjects = res.data
          if (res && res.data && res.data.length) {
            self.classesExam[index]['subjects'] = res.data
            self.acSetClassesExam([...self.classesExam])
            self.tabActive = res.data[0].subjectId
            self.acSetParamsGetQuestionsData({...this.paramsGetQuestionsSample, classId: item.classId, subjectId: res.data[0].subjectId})
          } else {
            self.acSetParamsGetQuestionsData({...this.paramsGetQuestionsSample, classId: item.classId, subjectId: 0})
          }
        })
      } else if (self.classesExam[index].subjects && self.classesExam[index].subjects.length > 0) {
        self.tabActive = self.classesExam[index].subjects[0].subjectId
        self.acSetParamsGetQuestionsData({...this.paramsGetQuestionsSample, classId: item.classId, subjectId: self.classesExam[index].subjects[0].subjectId})
      } else if (self.classesExam[index].subjects && self.classesExam[index].subjects.length === 0) {
        self.acSetParamsGetQuestionsData({...this.paramsGetQuestionsSample, classId: item.classId, subjectId: 0})
      }
    },

    changeSubjects(item,classId){
      this.tabActive = item.subjectId
      this.acSetParamsGetQuestionsData({...this.paramsGetQuestionsSample, subjectId: item.subjectId})
    },
  }
}
</script>

<style lang="scss" scoped>
.active{
  color: #0f3dba !important;
  font-family: 'sandisplaypro-semi';
}
</style>
